import common from '../common';
import ConveyorBelt from '../traps/ConveyorBelt';
export default class CrateObject extends THREE.Group {
	constructor() {
		super();

		this.canActivate = true;
		this.isMoving = false;
		this.onConveyor = false;
		this.model = null;
		this.destroyed = false;
		this.affectedTile = null;
		this.startTile = null;
		this.tweens = new P3.utils.TWEEN.Group();
		this.mainTween = new P3.utils.TWEEN.Group();
		this.crateHitWater = false;
		this._boxSound = null;

		this.startParameters = {
			position : new THREE.Vector3(0, 0, 0),
			rotation : new THREE.Euler(0, 0, 0)
		};

		this.init();
	}

	init() {
		this.model = common.environment === 0 ? common.assets.model('lab_crate_single') : common.assets.model('mine_crate_single');
		const map = this.model.material.map;
		this.model.material = new THREE.MeshBasicMaterial({
			map: map
		});

		this.add(this.model);

		this.startParameters.rotation.copy(this.rotation);
	}

	activate(data) {
		if (!this.canActivate || this.destroyed || this.onConveyor || this.crateHitWater) {
			return;
		}

		if (!this.startTile) {
			this.startTile = data.nextTile;
		}

		const delay = data.delay || 0;
		const time = data.time || 1000;

		if (data.action === 'push' && this.canActivate) {
			this.affectedTile = data.secondTile;

			if (this.affectedTile.types.includes('conveyor')) {
				this.onConveyor = true;
			}

			const destTilePos = data.secondTile.position3D;

			const sound = P3.audio.playSound('sfx_block_push_00', {loop: true});

			new P3.utils.TWEEN.Tween(this.position, this.mainTween)
				.to({
					x : destTilePos.x,
					z : destTilePos.z
				}, time)
				.easing(P3.utils.TWEEN.Easing.Linear.None)
				.delay(delay)
				.onStart(() => {
					if (!this._boxSound || !this._boxSound.playing) {
						this._boxSound = P3.audio.playSound('sfx_block_push_00', {
							callback: () => {
								this._boxSound.playing = false;
							}
						});
						this._boxSound.playing = true;
					}

					this.isMoving = true;
				})
				.onComplete(() => {
					if (data.secondTile.types.includes('conveyor')) {
						this.conveyorPush(data.secondTile);
					} else {
						this.isMoving = false;
					}

					sound.stop();
				})
				.start();

			data.nextTile.removeObject(this);
			data.secondTile.addObject(this);

			if (data.secondTile.isUnderwater && !data.secondTile.isWall) {
				this.boxFall(data.secondTile);
			}
		} else if (data.action === 'smash') {
			this.canActivate = false;
			this.destroyed = true;

			P3.utils.delay(delay / 1000, () => {
				P3.audio.playSound('sfx_crate_explode_00');
				this.model.parent.remove(this.model);
				this.model = common.assets.model('splinters');
				this.model.position.y -= 1.70;
				const texture = common.environment === 0 ? common.assets.texture('lab_crate') : common.assets.texture('mine_crate');
				texture.flipY = false;
				texture.encoding = THREE.sRGBEncoding;
				this.model.material.map = texture;
				this.model.material.needsUpdate = true;
				this.add(this.model);
			});
		}
	}

	conveyorPush(tile) {
		if (!this.canActivate || this.crateHitWater) {
			return;
		}

		const conveyor = tile.objects.find((element) => {
			return element instanceof ConveyorBelt;
		});

		if (!conveyor) {
			return;
		}

		this.onConveyor = true;

		// Update new tile
		const currentPos = Object.assign({}, tile.position);

		if (tile.types.includes('left') || tile.types.includes('right')) {
			currentPos.x += conveyor.direction.v;
		} else {
			currentPos.y += conveyor.direction.v;
		}

		// Tween to new tile
		const newTile = common.world.grid.getTileAt(currentPos.x, currentPos.y);

		this.affectedTile = newTile;

		new P3.utils.TWEEN.Tween(this.position, this.tweens)
			.to({
				x : newTile.position3D.x,
				z : newTile.position3D.z
			}, tile.objects[0].speed)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.onStart(() => {
				this.isMoving = true;

				tile.removeObject(this);
				newTile.addObject(this);
			})
			.onComplete(() => {
				if (newTile.types.includes('conveyor')) {
					this.conveyorPush(newTile);
				} else {
					this.isMoving = false;
					this.onConveyor = false;
					this.canActivate = true;
					if (newTile.isUnderwater && !newTile.isWall) {
						this.boxFall(newTile);
					}
				}
			})
			.start();

		// this.rotate(conveyor.direction.camrot * PIXI.DEG_TO_RAD, conveyor.speed - 100, false, true);
	}

	boxFall(tile) {
		if (!this.canActivate || this.crateHitWater) {
			return;
		}

		this.tweens.removeAll();

		this.canActivate = false;	// its now underwater so we cant push it anymore
		this.crateHitWater = true;
		tile.isUnderwater = false;

		new P3.utils.TWEEN.Tween(this.rotation, this.tweens)
			.to({
				z: -90 * PIXI.DEG_TO_RAD
			}, 400)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.onComplete(() => {
				P3.audio.playSound('sfx_die_water_00');
			})
			.delay(1000)
			.start();

		new P3.utils.TWEEN.Tween(this.position, this.tweens)
			.to({
				y: this.position.y - 3.3
			}, 200)
			.easing(P3.utils.TWEEN.Easing.Linear.None)
			.delay(1200)
			.start();
	}

	reset() {
		this.tweens.removeAll();
		this.model.parent.remove(this.model);
		this.model = common.environment === 0 ? common.assets.model('lab_crate_single') : common.assets.model('mine_crate_single');

		const texture = common.environment === 0 ? common.assets.texture('lab_crate') : common.assets.texture('mine_crate');
		texture.flipY = false;
		texture.encoding = THREE.sRGBEncoding;
		this.model.material.map = texture;
		this.model.material.needsUpdate = true;

		this.add(this.model);

		if (this.affectedTile) {
			this.affectedTile.removeObject(this);
			this.startTile.addObject(this);
		}

		this.rotation.copy(this.startParameters.rotation);
		this.position.copy(this.startParameters.position);

		if (this.crateHitWater) {
			this.affectedTile.isUnderwater = true;
		}

		this.startTile = null;
		this.crateHitWater = false;
		this.canActivate = true;
		this.destroyed = false;
		this.affectedTile = null;
		this.onConveyor = false;
		this.isMoving = false;
	}

	destroy() {
		this.model.geometry.dispose();
		this.model.material.dispose();
	}

	update() {
		this.tweens.update();
		this.mainTween.update();
	}
}
